import { store } from '../../store'
import { httpgst } from '../../main'

// Estatus por defecto cuando la vista todavía no manda uno (primer tab: creadas).
const DEFAULT_STATUS_ID = 1

// actions
const actions = {
  // GET api/petty-cash-request?user_id={id}&status_id={id}
  // El usuario y el estatus del tab van como query params. Un tab puede agrupar
  // varios estatus (enviadas = 2 y 3): se lanza una petición por cada uno y el
  // listado se arma hasta que todas terminan.
  get ({commit}, payload) {
    let url = 'api/petty-cash-request'
    let userId = store.state.userLogged.id
    let statusIds = payload.event.statusIds && payload.event.statusIds.length
      ? payload.event.statusIds
      : [DEFAULT_STATUS_ID]
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    Promise.all(statusIds.map(statusId => httpgst.get(url, {
      emulateJSON: false,
      params: {
        'user_id': userId,
        'status_id': statusId
      },
      headers: {
        'Content-Type': 'application/json'
      }
    })))
      .then(
        responses => {
          commit('onGet', {event: payload.event, responses: responses})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  // GET api/petty-cash-request?status_id={id}
  // Vista "Validar solicitud caja chica": status_id 2 = por validar, 3 = por aprobar.
  // El tab manda su statusId y la propiedad (key) donde deja el listado.
  getValidateRequestPettyCash ({commit}, payload) {
    let url = 'api/petty-cash-request'
    let options = {
      params: {
        'status_id': payload.event.statusId
      },
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, options)
      .then(
        response => {
          commit('onGetValidateRequestPettyCash', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  // POST api/petty-cash-request
  // La caja chica y la fecha las resuelve el backend a partir del usuario.
  // created_by sólo viaja cuando la solicitud se captura como representante, es
  // decir cuando el empleado elegido no es el usuario logueado; en las propias
  // va null.
  post ({commit}, payload) {
    let url = 'api/petty-cash-request'
    let loggedUserId = store.state.userLogged.id
    let params = {
      'user_id': payload.event.item.core_user_id,
      'amount': payload.event.item.amount,
      'description': payload.event.item.description,
      'project_id': payload.event.item.project_id,
      'created_by': payload.event.item.core_user_id === loggedUserId ? null : loggedUserId
    }

    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {})
      .then(
        response => {
          commit('onPost', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  // PUT api/petty-cash-request/{pettyCashRequest}
  // Mismos campos editables que el alta: empleado, proyecto, monto y descripción.
  // created_by se recalcula igual que en el alta, porque en la edición se puede
  // cambiar el empleado: si queda el usuario logueado deja de ser una solicitud
  // de representante y vuelve a null.
  put ({commit}, payload) {
    let url = 'api/petty-cash-request/' + payload.event.item.id
    let loggedUserId = store.state.userLogged.id
    let params = {
      'user_id': payload.event.item.core_user_id,
      'amount': payload.event.item.amount,
      'description': payload.event.item.description,
      'project_id': payload.event.item.project_id,
      'created_by': payload.event.item.core_user_id === loggedUserId ? null : loggedUserId
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.put(url, params, {})
      .then(
        response => {
          commit('onPut', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  // DELETE api/petty-cash-request/{pettyCashRequest}
  deletePetty ({commit}, payload) {
    let url = `api/petty-cash-request/${payload.event.item.id}`
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.delete(url, {}, {})
      .then(
        response => {
          commit('onDeletePetty', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  // GET api/petty-cash-request/validation/start/{pettyCashRequest}
  // Arranca el flujo de validación: la solicitud pasa de creada a enviada.
  startValidation ({commit}, payload) {
    let url = `api/petty-cash-request/validation/start/${payload.event.item.id}`
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {})
      .then(
        response => {
          commit('onStartValidation', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  // GET api/petty-cash-request/validation/validate/{pettyCashRequest}
  // Valida la solicitud desde la vista de aprobaciones (mismo endpoint en los
  // dos tabs). El backend avanza la solicitud al siguiente paso del flujo.
  validateRequestPettyCash ({commit}, payload) {
    let url = `api/petty-cash-request/validation/validate/${payload.event.item.id}`
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {})
      .then(
        response => {
          commit('onValidateRequestPettyCash', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  // PATCH api/petty-cash-request/validation/reject/{pettyCashRequest}
  // Rechazo desde la vista de aprobaciones: la solicitud regresa a su estatus
  // inicial y el motivo queda guardado en el historial de progreso.
  rejectRequestPettyCash ({commit}, payload) {
    let url = `api/petty-cash-request/validation/reject/${payload.event.item.id}`
    let params = {
      'reason': payload.event.item.reason
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.patch(url, params, {})
      .then(
        response => {
          commit('onRejectRequestPettyCash', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  // GET api/workflow-validator-approver/{user_id}
  // Flujo de validación configurado para el usuario de la solicitud: de ahí
  // salen los validadores y aprobadores que se pintan como pendientes en el
  // seguimiento.
  getWorkflowValidatorApprover ({commit}, payload) {
    let url = `api/workflow-validator-approver/${payload.event.user_id}`
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, options)
      .then(
        response => {
          commit('onGetWorkflowValidatorApprover', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

// mutations
const mutations = {
  // Llega una respuesta por cada estatus consultado; se concatenan sin repetir
  // ids por si una solicitud cae en más de un estatus.
  onGet (state, payload) {
    let items = []
    payload.responses.forEach(response => {
      let data = response.data.data || []
      data.forEach(item => {
        if (!items.some(x => x.id === item.id)) items.push(item)
      })
    })
    payload.event.context.pettyCash = items
    payload.event.context.loadingItems = false
  },
  onGetValidateRequestPettyCash (state, payload) {
    payload.event.context[payload.event.key] = payload.response.data.data
    payload.event.context.loadingDataTable = false
  },
  onValidateRequestPettyCash (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.closeValidation()
    payload.event.context.refresh()
  },
  // La solicitud rechazada vuelve al solicitante, así que sale del listado del
  // tab: se recarga igual que al validar.
  onRejectRequestPettyCash (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.closeRejection()
    payload.event.context.refresh()
  },
  // La solicitud se crea con el monto en una sola llamada: ya no hay que
  // encadenar el alta del movimiento (addCash) como en la caja chica de admin.
  onPost (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
    payload.event.context.refresh()
  },
  onPut (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
    payload.event.context.refresh()
  },
  onStartValidation (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
    payload.event.context.refresh()
  },
  onDeletePetty (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
    payload.event.context.refresh()
  },
  // La respuesta mezcla los pasos del flujo (traen id) con el catálogo de
  // aprobadores (viene al final, sin id). Los validadores se ordenan siguiendo
  // is_first_step / next_step, igual que en el seguimiento de gastos.
  onGetWorkflowValidatorApprover (state, payload) {
    let validators = []
    let approvers = []
    let counter = 0
    let approverByFlow = 0
    const responseValidatorsApprovers = Object.assign({}, payload.response.data.data)
    const listValidatorsApprovers = Object.getOwnPropertyNames(responseValidatorsApprovers)

    listValidatorsApprovers.forEach(i => {
      let el = responseValidatorsApprovers[i]
      el = { ...el }
      if (el.id) {
        counter++
        el.validatorId = counter
        validators.push(el)
        if (el.gst_approver_id > 0) approverByFlow = el.gst_approver_id
      } else {
        if (approverByFlow > 0) approvers.push(Object.values(el).find(obj => obj.id === approverByFlow))
        if (approvers.length === 0) approvers.push(Object.values(el).find(obj => obj.is_default === 1))
      }
    })

    const orderValidators = list => {
      let counter = 0
      let newList = []
      let first = list.find(x => x.is_first_step === 1)
      if (first !== undefined) {
        counter++
        first.validatorId = counter
        newList.push(first)
        let next = first.next_step
        list.forEach(i => {
          let newNext = list.find(x => x.id === next)
          if (newNext !== undefined) {
            counter++
            newNext.validatorId = counter
            newList.push(newNext)
            next = newNext.next_step
          }
        })
      }
      return newList
    }

    payload.event.context.validators = orderValidators(validators)
    // find() regresa undefined cuando el flujo no tiene aprobador configurado.
    payload.event.context.approvers = approvers.filter(x => x !== undefined)
    payload.event.context.histLoading = false
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
      payload.event.context.loading = false
    }

    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loading = false
    payload.event.context.loadingItems = false
    payload.event.context.loadingDataTable = false
    payload.event.context.histLoading = false
  }
}

export default {
  namespaced: true,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/requestPettyCash.js